// import React, { useEffect, useState } from 'react';
// // import Select from 'react-select';
// import SweetAlert from '../../Shared/Notification';
// import OptionModal from '../../Modals/OptionModal';
// import { useNavigate, useParams } from 'react-router-dom';
// import APIService from '../../../Services/APIService';
// import TableHeader from '../../Shared/TableHeader';
// import { BackButton } from '../../Shared/BackButton';
// import {
//   Form,
//   Button,
//   Row,
//   Col,
//   FormControl,
//   FormGroup,
//   FormCheck,
//   FormLabel,
// } from 'react-bootstrap';
// import SelectDropdown from '../../Shared/SelectDropdown';
// import ErrorWrapper from '../../Shared/ErrorWrapper';

// const CreateInventory = () => {
//   const navigation = useNavigate();
//   const params = useParams();
//   const inventoryId = params.inventoryId;

//   const [name, setName] = useState('');
//   const [inventoryAttributes, setInventoryAttributes] = useState([
//     { name: '', type: '', is_required: false },
//   ]);
//   const [baseInventoryOptions, setBaseInventoryOptions] = useState([]);
//   const [selectedBaseInventory, setSelectedBaseInventory] = useState('');
//   const [selectedBaseInventoryId, setSelectedBaseInventoryId] = useState('');
//   const [showOptionModal, setShowOptionModal] = useState(false);
//   const [attributeOptions, setAttributeOptions] = useState(['']);
//   const [attributeInfo, setAttributeInfo] = useState({});
//   const [mode, setMode] = useState('create');
//   const [errors, setErrors] = useState({});

//   const getBaseInventory = async () => {
//     let res = await APIService.get(`/v0/ui/dynamic-inventory/base-inventory/`);
//     if (res.status == 200) {
//       setBaseInventoryOptions(res?.data?.list);
//     }
//   };

//   const getInventoryById = async (id) => {
//     let res = await APIService.get(`/v0/ui/dynamic-inventory/inventory/${id}/`);
//     if (res.status == 200) {
//       setName(res?.data?.name);
//       setSelectedBaseInventoryId(res?.data?.base_inventory);
//       setInventoryAttributes(res?.data?.inventory_attributes);
//     }
//   };

//   const optionStyle = {
//     fontSize: '12px',
//     margin: '0',
//     marginTop: '5px',
//     textDecoration: 'underline',
//     cursor: 'pointer',
//     paddingBottom: '10px',
//   };

//   const AttributeTypes = [
//     { value: 'FLOAT', label: 'Float' },
//     { value: 'STRING', label: 'Text' },
//     { value: 'DROPDOWN', label: 'Dropdown' },
//     { value: 'EMAIL', label: 'Email' },
//     { value: 'MULTISELECT', label: 'Multi Select' },
//   ];

//   // Get attribute type option from string
//   const getAttributeTypeOption = (value) => {
//     for (let i = 0, l = AttributeTypes.length; i < l; i += 1) {
//       if (AttributeTypes[i].value === value) {
//         return AttributeTypes[i];
//       }
//     }

//     return ;
//   };

//   const validate = (data) => {
//     const errors = {};

//     if (!data.name.trim()) {
//       errors.name = {
//         message: 'Please enter a name for base booking',
//       };
//     }

//     if (!data.base_inventory) {
//       errors.base_inventory = {
//         message: 'Please select base inventory',
//       };
//     }

//     for (let i = 0; i < data.inventory_attributes.length; i++) {
//       let attr = 'attribute' + i;
//       let type = 'type' + i;
//       if (!data.inventory_attributes[i].name) {
//         errors[attr] = {
//           message: 'This field should not be blank',
//         };
//       }

//       if (!data.inventory_attributes[i].type) {
//         errors[type] = {
//           message: 'Please select the type',
//         };
//       }

//       if (
//         (data.inventory_attributes[i].type == 'DROPDOWN' ||
//           data.inventory_attributes[i].type == 'HASHTAG' ||
//           data.inventory_attributes[i].type == 'MULTISELECT') &&
//         (!data.inventory_attributes[i].hasOwnProperty('options') ||
//           data.inventory_attributes[i].options.length == 0 ||
//           data.inventory_attributes[i].options.indexOf('') > -1)
//       ) {
//         let opt = 'options' + i;
//         errors[opt] = {
//           message: 'Please fill the options',
//         };
//       }
//     }
//     return errors;
//   };

//   const onCancelOptionModal = () => {
//     setShowOptionModal(false);
//     setAttributeOptions(['']);
//     setAttributeInfo({});
//   };

//   const onSubmitOptionModal = (options, attributeInfo) => {
//     setShowOptionModal(false);
//     setAttributeOptions(['']);
//     setAttributeInfo({});


//     let newAttributes = Object.assign({}, attributeInfo.attribute, {
//       type: attributeInfo.attributeType,
//       options: options,
//     });
//     handleAttributeChange(newAttributes, attributeInfo.attrIndex);

//   };

//   const onOpenOptionModal = (options, attributeType, attribute, attrIndex) => {
//     setShowOptionModal(true);
//     setAttributeOptions(options);
//     setAttributeInfo({
//       attributeType,
//       attribute,
//       attrIndex,
//     });
//   };

//   const onSubmit = async (e) => {
//     e.preventDefault();
//     let data = {
//       name: name,
//       base_inventory: selectedBaseInventory._id || selectedBaseInventoryId,
//       inventory_attributes: inventoryAttributes,
//     };
//     const errors = validate(data);  
//     if (Object.keys(errors).length) {
//       setErrors(errors);
//     } else {
//       if (mode === 'create') {
//         let res = await APIService.post(`/v0/ui/dynamic-inventory/inventory/`, data);
//         if (res.status == 200) {
//           SweetAlert('Inventory created successfully', 'success');
//           navigation('/r/inventory/list');
//         }
//       } else if (mode === 'edit') {
//         let res = await APIService.put(`/v0/ui/dynamic-inventory/inventory/${inventoryId}/`, data);
//         if (res.status == 200) {
//           SweetAlert('Inventory updated successfully', 'success');
//           navigation('/r/inventory/list');
//         }
//       } else {
//         console.log('Error: Unsupported mode!');
//       }
//     }
//   };

//   const onAddAttribute = () => {
//     let newAttributes = [...inventoryAttributes];
//     newAttributes = newAttributes.slice();
//     newAttributes.push({
//       name: '',
//       type: '',
//       is_required: false,
//     });
//     setInventoryAttributes(newAttributes);
//   };

//   const onRemoveAttribute = (e, index) => {
//     let attributes = [...inventoryAttributes];
//     attributes = attributes.slice();
//     attributes.splice(index, 1);
//     setInventoryAttributes(attributes);
//   };

//   const handleAttributeChange = (attribute, index) => {
//     let attributes = [...inventoryAttributes];
//     attributes = attributes.slice();
//     attributes.splice(index, 1, attribute);
//     setInventoryAttributes(attributes);
//   };

//   const onBaseInventoryChange = (selectedBaseInventory) => {
//     setSelectedBaseInventory(selectedBaseInventory);
//     setInventoryAttributes(selectedBaseInventory?.base_attributes);
//   };

//   const renderAttributeRow = (attribute, attrIndex) => {
//     const onNameChange = (e) => {
//       const newAttribute = Object.assign({}, attribute);
//       newAttribute.name = e.target.value;
//       handleAttributeChange(newAttribute, attrIndex);
//     };

//     const onTypeChange = (item) => {
//       if (item.value === 'DROPDOWN' || item.value === 'MULTISELECT') {
//         setShowOptionModal(true);
//         // setColumnOptions([''])
//         setAttributeInfo({
//           attributeType: item.value,
//           attribute,
//           attrIndex,
//         });
//         return;
//       }

//       const newAttribute = Object.assign({}, attribute);
//       newAttribute.type = item.value;
//       handleAttributeChange(newAttribute, attrIndex);
//       console.log(newAttribute);
//     };

//     const onRequiredChange = (e) => {
//       const newAttribute = Object.assign({}, attribute);
//       newAttribute.is_required = !!e.target.checked;
//       handleAttributeChange(newAttribute, attrIndex);
//     };

//     return (
//       <Row key={`row-${attrIndex}`}>
//         <Col>
//           <FormGroup className="my-2">
//             <FormControl
//               type="text"
//               placeholder="Name"
//               value={attribute.name}
//               onChange={(e) => onNameChange(e)}
//               className={{ error: errors['attribute' + attrIndex] }}
//             />
//             {errors && errors['attribute' + attrIndex] ? (
//               <p className="message message--error">{errors['attribute' + attrIndex].message}</p>
//             ) : null}
//           </FormGroup>
//         </Col>

//         <Col>
//           <SelectDropdown
//             optionsData={AttributeTypes}
//             isClearable={false}
//             placeholder={'Select'}
//             className="form-select"
//             selectedValue={getAttributeTypeOption(attribute.type)}
//             // onChange={(e) => onTypeChange(e)}
//             handleSelect={onTypeChange}
//           />




//           {attribute.type === 'DROPDOWN' || attribute.type === 'MULTISELECT' ? (
//             <p
//               className="show-option"
//               style={optionStyle}
//               onClick={() =>
//                 onOpenOptionModal(attribute.options, attribute.type, attribute, attribute.attrIndex)
//               }
//             >
//               Show Options
//             </p>
//           ) : (
//             ''
//           )}
//           {errors && errors['options' + attrIndex] ? (
//             <p className="message message--error">{errors['options' + attrIndex].message}</p>
//           ) : null}
//           {errors && errors['type' + attrIndex] ? (
//             <p className="message message--error">{errors['type' + attrIndex].message}</p>
//           ) : null}

//         </Col>
//         <Col>
//           <FormGroup className="inline my-1.5 border border-primary p-2">
//             <Form.Check
//               type="checkbox"
//               name="option"
//               label={'Is it required ?'}
//               value={attribute.is_required}
//               checked={attribute.is_required}
//               onChange={(e) => onRequiredChange(e)}
//             />
//           </FormGroup>
//         </Col>
//         <Col>
//           {mode === 'edit' ? null : (
//             <Button
//               type="button"
//               className="btn btn--primary ml-2"
//               onClick={(e) => onRemoveAttribute(e, attrIndex)}
//             >
//               Remove Attribute
//             </Button>
//           )}
//         </Col>
//       </Row>
//     );
//   };
//   const backButton = () => {
//     return <BackButton onClick={() => navigation(`/r/inventory/list`)} />;
//   };
//   useEffect(() => {
//     getBaseInventory();
//     if (inventoryId) {
//       setMode('edit');
//       getInventoryById(inventoryId);
//     }
//   }, []);

//   useEffect(() => {
//     if (baseInventoryOptions.length) {
//       let obj =
//         baseInventoryOptions &&
//         baseInventoryOptions.find((item) => item._id == selectedBaseInventoryId);
//       setSelectedBaseInventory(obj);
//     }
//   }, [baseInventoryOptions]);

//   return (
//     <>
//       <TableHeader
//         headerValue={`${mode === 'edit' ? 'Edit' : 'Create'} Inventory`}
//         isBackButton={backButton}
//       />
//       <Form onSubmit={onSubmit}>
//         <Row>
//           <Col>
//             <FormGroup>
//               <Form.Label>
//                 Enter Inventory Name <span className="required-field">*</span>
//               </Form.Label>
//               <FormControl
//                 type="text"
//                 name="name"
//                 value={name}
//                 onChange={(e) => setName(e.target.value)}
//                 className={{ error: errors.name }}
//               />
//               {errors && errors.name ? <ErrorWrapper error={errors.name.message} /> : null}
//             </FormGroup>
//           </Col>

//           <Col>
//             <FormGroup>
//               <Form.Label>
//                 Select Base Inventory <span className="required-field">*</span>
//               </Form.Label>
//               <SelectDropdown
//                 optionsData={baseInventoryOptions}
//                 OptionLabel="name"
//                 OptionValue="_id"
//                 selectedValue={selectedBaseInventory}
//                 handleSelect={onBaseInventoryChange}
//                 isDisabled={mode === 'edit'}
//               />
//               {errors.base_inventory ? (
//                 <ErrorWrapper error={errors.base_inventory.message} />
//               ) : null}
//             </FormGroup>
//           </Col>

//           <Form.Label className="form-label">Attributes</Form.Label>

//           <div>{inventoryAttributes && inventoryAttributes.map(renderAttributeRow)}</div>

//           <div className="mt-4">
//             <Button variant="primary" onClick={onAddAttribute} style={{ marginRight: '10px' }}>
//               Add Attribute
//             </Button>

//             <Button type="submit" variant="primary">
//               Submit
//             </Button>
//           </div>
//         </Row>
//       </Form>
//       <OptionModal
//         key={attributeInfo?.attrIndex}
//         showOptionModal={showOptionModal}
//         onCancel={onCancelOptionModal}
//         onSubmit={onSubmitOptionModal}
//         options={attributeOptions}
//         columnInfo={attributeInfo}
//       />
//        {console.log("attributeOptions:", attributeOptions)};
//     </>

//   );
// };
// export default CreateInventory;


import React, { useEffect, useState } from 'react';
import OptionModal from '../../Modals/OptionModal.tsx';
import { useNavigate, useParams } from 'react-router-dom';
import APIService from '../../../Services/APIService';
import { BackButton } from '../../Shared/BackButton';
import SelectDropdown from '../../Shared/SelectDropdown';
import { Box, Button, Checkbox, FormControl, FormControlLabel, FormGroup, FormHelperText, Grid, Input, InputLabel, TextField, Typography } from '@mui/material';
import { useSnackBar } from '../../FlowBuilder/Common/SnackBar/index.tsx';
import SearchableDropdown from '../../FlowBuilder/Common/SearchableDropdown/SearchableDropdown.tsx';

const CreateInventory = () => {
  const navigation = useNavigate();
  const params = useParams();
  const inventoryId = params.inventoryId;
  const { showSnackBar } = useSnackBar();
  const [name, setName] = useState('');
  const [inventoryAttributes, setInventoryAttributes] = useState([
    { name: '', type: '', is_required: false },
  ]);
  const [baseInventoryOptions, setBaseInventoryOptions] = useState([]);
  const [selectedBaseInventory, setSelectedBaseInventory] = useState('');
  const [selectedBaseInventoryId, setSelectedBaseInventoryId] = useState('');
  const [showOptionModal, setShowOptionModal] = useState(false);
  const [attributeOptions, setAttributeOptions] = useState(['']);
  const [attributeInfo, setAttributeInfo] = useState({});
  const [mode, setMode] = useState('create');
  const [errors, setErrors] = useState({});

  const getBaseInventory = async () => {
    let res = await APIService.get(`/v0/ui/dynamic-inventory/base-inventory/`);
    if (res.status == 200) {
      setBaseInventoryOptions(res?.data?.list);
    }
  };

  const getInventoryById = async (id) => {
    let res = await APIService.get(`/v0/ui/dynamic-inventory/inventory/${id}/`);
    if (res.status == 200) {
      setName(res?.data?.name);
      setSelectedBaseInventoryId(res?.data?.base_inventory);
      setInventoryAttributes(res?.data?.inventory_attributes);
    }
  };

  const optionStyle = {
    fontSize: '12px',
    margin: '0',
    marginTop: '5px',
    textDecoration: 'underline',
    cursor: 'pointer',
    paddingBottom: '10px',
  };

  const AttributeTypes = [
    { value: 'FLOAT', label: 'Float' },
    { value: 'STRING', label: 'Text' },
    { value: 'DROPDOWN', label: 'Dropdown' },
    { value: 'EMAIL', label: 'Email' },
    { value: 'MULTISELECT', label: 'Multi Select' },
  ];

  const getAttributeTypeOption = (value) => {
    for (let i = 0, l = AttributeTypes.length; i < l; i += 1) {
      if (AttributeTypes[i].value === value) {
        return AttributeTypes[i];
      }
    }
    return;
  };

  const validate = (data) => {
    const errors = {};
    if (!data.name.trim()) {
      errors.name = {
        message: 'Please enter a name for base booking',
      };
    }
    if (!data.base_inventory) {
      errors.base_inventory = {
        message: 'Please select base inventory',
      };
    }
    for (let i = 0; i < data.inventory_attributes.length; i++) {
      let attr = 'attribute' + i;
      let type = 'type' + i;
      if (!data.inventory_attributes[i].name) {
        errors[attr] = {
          message: 'This field should not be blank',
        };
      }
      if (!data.inventory_attributes[i].type) {
        errors[type] = {
          message: 'Please select the type',
        };
      }
      if (
        (data.inventory_attributes[i].type == 'DROPDOWN' ||
          data.inventory_attributes[i].type == 'HASHTAG' ||
          data.inventory_attributes[i].type == 'MULTISELECT') &&
        (!data.inventory_attributes[i].hasOwnProperty('options') ||
          data.inventory_attributes[i].options.length == 0 ||
          data.inventory_attributes[i].options.indexOf('') > -1)
      ) {
        let opt = 'options' + i;
        errors[opt] = {
          message: 'Please fill the options',
        };
      }
    }
    return errors;
  };

  const onCancelOptionModal = () => {
    setShowOptionModal(false);
    setAttributeOptions(['']);
    setAttributeInfo({});
  };

  const onSubmitOptionModal = (options, attributeInfo) => {
    setShowOptionModal(false);
    setAttributeOptions(['']);
    setAttributeInfo({});
    let newAttributes = Object.assign({}, attributeInfo.attribute, {
      type: attributeInfo.attributeType,
      options: options,
    });
    handleAttributeChange(newAttributes, attributeInfo.attrIndex);

  };

  const onOpenOptionModal = (options, attributeType, attribute, attrIndex) => {
    setShowOptionModal(true);
    setAttributeOptions(options);
    setAttributeInfo({
      attributeType,
      attribute,
      attrIndex,
    });
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    const baseInventoryId = selectedBaseInventory ? selectedBaseInventory._id : selectedBaseInventoryId;

    let data = {
      name: name,
      base_inventory: baseInventoryId,
      inventory_attributes: inventoryAttributes,
    };
    const errors = validate(data);
    if (Object.keys(errors).length) {
      setErrors(errors);
    } else {
      if (mode === 'create') {
        let res = await APIService.post(`/v0/ui/dynamic-inventory/inventory/`, data);
        if (res.status == 200) {
          showSnackBar('Inventory created successfully', 'success');
          navigation('/r/inventory/list');
        }
      } else if (mode === 'edit') {
        let res = await APIService.put(`/v0/ui/dynamic-inventory/inventory/${inventoryId}/`, data);
        if (res.status == 200) {
          showSnackBar('Inventory updated successfully', 'success');
          navigation('/r/inventory/list');
        }
      } else {
        console.log('Error: Unsupported mode!');
      }
    }
  };

  const onAddAttribute = () => {
    let newAttributes = [...inventoryAttributes];
    newAttributes = newAttributes.slice();
    newAttributes.push({
      name: '',
      type: '',
      is_required: false,
    });
    setInventoryAttributes(newAttributes);
  };

  const onRemoveAttribute = (e, index) => {
    let attributes = [...inventoryAttributes];
    attributes = attributes.slice();
    attributes.splice(index, 1);
    setInventoryAttributes(attributes);
  };

  const handleAttributeChange = (attribute, index) => {
    let attributes = [...inventoryAttributes];
    attributes = attributes.slice();
    attributes.splice(index, 1, attribute);
    setInventoryAttributes(attributes);
  };

  const onBaseInventoryChange = (selectedBaseInventory) => {
    setSelectedBaseInventory(selectedBaseInventory);
    setInventoryAttributes(selectedBaseInventory?.base_attributes);
  };

  const renderAttributeRow = (attribute, attrIndex) => {
    const onNameChange = (e) => {
      const newAttribute = Object.assign({}, attribute);
      newAttribute.name = e.target.value;
      handleAttributeChange(newAttribute, attrIndex);
    };

    const onTypeChange = (item) => {
      if (item.value === 'DROPDOWN' || item.value === 'MULTISELECT') {
        setShowOptionModal(true);
        // setColumnOptions([''])
        setAttributeInfo({
          attributeType: item.value,
          attribute,
          attrIndex,
        });
        return;
      }

      const newAttribute = Object.assign({}, attribute);
      newAttribute.type = item.value;
      handleAttributeChange(newAttribute, attrIndex);
      console.log(newAttribute);
    };

    const onRequiredChange = (e) => {
      const newAttribute = Object.assign({}, attribute);
      newAttribute.is_required = !!e.target.checked;
      handleAttributeChange(newAttribute, attrIndex);
    };

    return (
      <Grid container spacing={2} key={`row-${attrIndex}`} sx={{mb:1 ,alignItems:'baseline'}}>
        <Grid item xs={12} sm={3}>
          <TextField
            fullWidth
            name="name"
            placeholder="Name"
            value={attribute.name}
            onChange={(e) => onNameChange(e)}
            error={Boolean(errors['attribute' + attrIndex])}
            helperText={errors['attribute' + attrIndex]?.message}
            InputProps={{
              sx: {
                '& input': {
                  padding: '8px',
                },
              },
            }}
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <SearchableDropdown
            options={AttributeTypes}
            isClearable={false}
            placeholder={'Select'}
            value={getAttributeTypeOption(attribute.type)}
            onChange={onTypeChange}
            error={errors && errors['type' + attrIndex]}
            errorMessage={errors && errors['type' + attrIndex]?.message}
          />

          {attribute.type === 'DROPDOWN' || attribute.type === 'MULTISELECT' ? (
            <p
              className="show-option"
              style={optionStyle}
              onClick={() =>
                onOpenOptionModal(attribute.options, attribute.type, attribute, attribute.attrIndex)
              }
            >
              Show Options
            </p>
          ) : null}
        </Grid>

        <Grid item xs={12} sm={3}>
          <FormControlLabel
            control={
              <Checkbox
                checked={attribute.is_required}
                onChange={(e) => onRequiredChange(e)}
                name="option"
              />
            }
            label="Is it required?"
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          {mode === 'edit' ? null : (
            <Button
              size='small'
              variant="contained"
              color="primary"
              onClick={(e) => onRemoveAttribute(e, attrIndex)}
            >
              Remove Attribute
            </Button>
          )}
        </Grid>
      </Grid>
    );
  };
  useEffect(() => {
    getBaseInventory();
    if (inventoryId) {
      setMode('edit');
      getInventoryById(inventoryId);
    }
  }, []);

  useEffect(() => {
    if (baseInventoryOptions.length) {
      let obj =
        baseInventoryOptions &&
        baseInventoryOptions.find((item) => item._id == selectedBaseInventoryId);
      setSelectedBaseInventory(obj);
    }
  }, [baseInventoryOptions]);

  return (
    <Box sx={{ backgroundColor: '#f8f9fa', borderRadius: '8px', p: 1 }}>
      <Grid container justifyContent="space-between" alignItems="center">
        <Grid item>
          <Typography variant="h4" fontWeight="bold">
            {`${mode === 'edit' ? 'Edit' : 'Create'} Inventory`}
          </Typography>
        </Grid>
        <Grid item>
          <BackButton onClick={() => navigation(`/r/inventory/list`)} />
        </Grid>
      </Grid>
      <Box component="form" onSubmit={onSubmit} noValidate>
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <Typography variant="body1" sx={{mb:1}}>
              Enter Inventory Name<span style={{ color: 'red' }}>*</span>
            </Typography>
            <TextField
              fullWidth
              name="name"
              placeholder="Enter Inventory Name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              error={Boolean(errors?.name)}
              helperText={errors?.name?.message}
              InputProps={{
                sx: {
                  '& input': {
                    padding: '8px', 
                  },
                },
              }}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <InputLabel sx={{mb:1}}>
              Select Base Inventory <span className="required-field">*</span>
            </InputLabel>
            <FormControl fullWidth error={Boolean(errors.base_inventory)}>
              <SearchableDropdown
                options={baseInventoryOptions}
                labelKey="name"
                valueKey="_id"
                value={selectedBaseInventory}
                onChange={onBaseInventoryChange}
                error={Boolean(errors.base_inventory)}
                errorMessage={errors.base_inventory?.message}
                disabled={mode === 'edit'}
                size="small"
              />
            </FormControl>
          </Grid>


          <Grid item xs={12}>
            <Typography variant="h6" className="form-label">
              Attributes
            </Typography>
            <div>{inventoryAttributes && inventoryAttributes.map(renderAttributeRow)}</div>
          </Grid>

          <Grid item xs={12}>
            <Button
              size='small'
              variant="contained"
              color="primary"
              onClick={onAddAttribute}
              style={{ marginRight: '10px' }}
            >
              Add Attribute
            </Button>

            <Button size='small' variant="contained" color="primary" type="submit">
              Submit
            </Button>
          </Grid>
        </Grid>
      </Box>
      <OptionModal
        key={attributeInfo?.attrIndex}
        showOptionModal={showOptionModal}
        onCancel={onCancelOptionModal}
        onSubmit={onSubmitOptionModal}
        options={attributeOptions}
        columnInfo={attributeInfo}
      />
    </Box>
  );
};
export default CreateInventory;
